class DragNDropHelpers {
  /**
   * Adapter for @dnd-kit's drag-end event. Maps `{ active, over }` (id-based) to
   * list indices and reuses `reorder`, so call sites keep the same
   * `(reorderedList) => void` callback they used with react-beautiful-dnd.
   *
   * @param {Array} list - the current ordered list
   * @param {{active: {id}, over: ?{id}}} event - dnd-kit onDragEnd event
   * @param {(reordered: Array) => any} callback - receives the reordered list
   * @param {(item: any) => string|number} [getId] - how to derive an item's id
   *   (defaults to identity; pass `(item) => item.id` for object lists)
   */
  onDndKitDragEnd(list, event, callback, getId = (item) => item) {
    const { active, over } = event;

    if (!over || active.id === over.id) {
      return null;
    }

    const from = list.findIndex((item) => getId(item) === active.id);
    const to = list.findIndex((item) => getId(item) === over.id);

    if (from === -1 || to === -1) {
      return null;
    }

    return callback(this.reorder(list, from, to));
  }

  onDragEnd(list, result, callback) {
    if (!result.destination) {
      return null;
    }

    if (result.destination.index === result.source.index) {
      return null;
    }

    return callback(this.reorder(list, result.source.index, result.destination.index));
  }

  reorder(list, startIndex, endIndex) {
    try {
      const result = Array.from(list);
      const [removed] = result.splice(startIndex, 1);
      result.splice(endIndex, 0, removed);

      return result;
    } catch (error) {
      return null;
    }
  }
}

export default new DragNDropHelpers();
